module.exports = __webpack_public_path__ + "img/第4章_3-1_元清觀.jpg";